export const faqItems = [
  {
    question: '人渣游戏适合什么样的玩家？',
    answer: '人渣游戏适合喜欢硬核生存体验、不介意学习复杂系统的玩家。如果你享受在严酷环境中通过自己的智慧和努力存活下来的成就感，这款游戏会给你带来极大的满足。但如果你偏好轻松休闲的游戏体验，可能需要慎重考虑。',
  },
  {
    question: '人渣游戏需要多高的电脑配置？',
    answer: '人渣游戏对硬件有一定要求。推荐配置：CPU i5-6600K或以上，显卡 GTX 1060 6GB或以上，内存 16GB，并建议将游戏安装在SSD上以获得更好的加载体验。由于游戏仍在持续优化中，实际性能可能因版本而异。',
  },
  {
    question: '人渣游戏可以单人玩吗？',
    answer: '可以。游戏提供了单人模式，你可以离线独自探索整个岛屿。不过需要注意的是，游戏的某些内容（如高级区域探索和BOSS战）在单人模式下难度会显著提升。建议新手先在单人模式中熟悉机制，再进入多人服务器。',
  },
  {
    question: '游戏中的暴力内容可以关闭吗？',
    answer: '游戏目前不提供暴力内容的过滤选项。人渣游戏作为一款成人向作品，其核心体验就包含了较为直白的暴力表现。如果你对这方面内容比较敏感，建议在购买前充分了解游戏的实际内容。',
  },
  {
    question: '人渣游戏未来还会更新什么内容？',
    answer: '根据开发团队的路线图，未来还将推出更多地图区域、载具系统、更加完善的NPC阵营系统以及故事模式的完整剧情线。开发团队承诺将持续对游戏进行内容更新和技术优化。',
  },
  {
    question: '人渣游戏有中文吗？',
    answer: '游戏目前支持简体中文界面和字幕。中文翻译质量在社区的努力下不断提升，大部分核心内容都已经完成了汉化。',
  },
  {
    question: '人渣游戏是买断制还是免费游戏？',
    answer: '人渣游戏采用买断制收费模式，一次购买即可永久游玩。游戏不含付费道具或内购系统，所有内容都可以通过游戏内的努力获得。Steam平台经常会有折扣活动，可以关注促销信息。',
  },
];

export const reputationItems = [
  {
    name: 'GameStar',
    rating: 8.2,
    comment: '人渣游戏在生存模拟方面的深度令人印象深刻。虽然技术层面还有待完善，但其独特的健康系统和开放世界设计值得每位生存游戏爱好者体验。',
    logo: 'GS',
  },
  {
    name: 'IGN中国',
    rating: 7.5,
    comment: '一款野心勃勃的作品。人渣游戏展现了极高的创意水准，但在执行上略显粗糙。如果你能接受它的粗糙外表，会发现内部有令人惊喜的深度。',
    logo: 'IGN',
  },
  {
    name: '游民星空',
    rating: 8.0,
    comment: '国内玩家对人渣游戏的评价呈现两极分化，但不可否认的是，它在生存模拟这个细分品类中做到了极致。对于核心玩家来说，这是一款不可错过的作品。',
    logo: '游民',
  },
  {
    name: 'Steam社区',
    rating: 7.8,
    comment: '特别好评的背后是无数小时的沉浸体验。玩家们对人渣游戏又爱又恨——爱它的深度，恨它的BUG。但正是这种复杂情感，让这款游戏如此特别。',
    logo: 'ST',
  },
];